export default __webpack_public_path__ + "static/media/inviteSignup1.04fde3b0.svg";